import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { usersList } from "constants/users";
import { assignLocationList } from "constants/assignLocation";

//get sub-user list
export const getSubUserList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_sub_user_list(pageNum, filters);
    dispatch({ type: usersList, payload: res.data });
  } catch (error) {
    dispatch({ type: usersList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

// add sub-user
export const addSubUser = async (bodyData) => {
  try {
    const res = await api.add_sub_user(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//get sub-user detail by id
export const getSubUserByID = async (id) => {
  try {
    const res = await api.get_sub_user_detail_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//edit user
export const updateSubUser = async (id, bodyData) => {
  try {
    const res = await api.update_sub_user_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//assign location to sub user
export const addAssignLocation = async (bodyData) => {
  try {
    const res = await api.assign_location_sub_user(bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//get list of assign location
export const getListAssignLocation = async (
  dispatch,
  id,
  pageNum,
  params,
  filters,
  searchString,
) => {
  try {
    const res = await api.get_list_assign_location(
      id,
      pageNum,
      params,
      filters,
      searchString,
    );
    dispatch({
      type: assignLocationList,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: assignLocationList,
      payload: error?.response?.data || error,
    });

    authorizedUser(error.response?.data);
  }
};

//get user detail by id
export const getUserByID = async (id) => {
  try {
    const res = await api.get_user_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//edit user
export const editUser = async (id, bodyData) => {
  try {
    const res = await api.edit_user(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//change user password
export const changeUserPassword = async (id, bodyData) => {
  try {
    const res = await api.change_password(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
